import React from "react";

import classNames from "classnames";
import { MenuItem, Paper, MenuList } from "material-ui";
import { withStyles } from "material-ui/styles";
import { Popper } from "react-popper";
import ClickAwayListener from "material-ui/utils/ClickAwayListener";
import Grow from "material-ui/transitions/Grow";

const styles = theme => ({
  info: {
    color: "black",
    padding: "10px 20px",
    borderBottom: "1px solid lightgray",
    fontSize: "1.1rem"
  },
  menuItem: {
    color: theme.palette.link
  },
  hide: {
    display: "none"
  },
  popperClose: {
    pointerEvents: "none"
  }
});

const HeaderMenu = props => {
  const { classes, customerName, surveyName } = props;

  return (
    <div>
      <Popper
        placement="bottom-end"
        eventsEnabled={props.open}
        style={{ zIndex: 999, maxWidth: "90%" }}
        className={classNames({ [props.classes.popperClose]: !props.open })}
      >
        <ClickAwayListener onClickAway={props.closeMenu}>
          <Grow
            in={props.open}
            id={props.menuId}
            style={{
              transformOrigin: "0 0 0",
              left: -30
            }}
          >
            <Paper>
              <div className={classes.info}>
                <div>{customerName}</div>
                <div>{surveyName}</div>
              </div>

              <MenuList role="menu">
                <MenuItem
                  className={classes.menuItem}
                  onClick={() => props.handleLogout()}
                >
                  ログアウト
                </MenuItem>
              </MenuList>
            </Paper>
          </Grow>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export default withStyles(styles)(HeaderMenu);



// WEBPACK FOOTER //
// ./src/components/answer/HeaderMenu.js